var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.handleClick}},[_vm._v("同程测试任务")])])
}
var staticRenderFns = []

export { render, staticRenderFns }